export default __webpack_public_path__ + "static/media/board.f6981315.png";